import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'
import { isData } from "root/tools.js"

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		areas: [],
		customers: [],
		users: [],
		graves: [],
		deceaseds: [],
		contact_types: [],
		address_types: [],
		zips: [],
		categories: [],
		grave_types: [],
		crematories: [],
		undertakers: [],
		burial_types: [],
		denominations: [],
		roles: [],
		graveyards: [],

		graveyard_id: 0,
		allAreas: [{coordinates: "52 40.614,8 48.757"}],
		localCriteria: {}
	},

	getters: {
		allAreas: (state, getters) => {
			return state.allAreas.map(Item => {
				return {
					base_id: Item.base_id,
					category_id: Item.categories,
					category_price: Item.category_price,
					changed_by: Item.changed_by,
					coordinates: Item.coordinates,
					created: Item.created,
					customer_count: Item.customer_count,
					deceased_count: Item.deceased_count,
					deleted: Item.deleted,
					description: Item.description,
					grave_count: Item.grave_count,
					graveyard_id: Item.graveyard_id,
					graveyard_name: Item.graveyard_name,
					id: Item.id,
					name: Item.name,
					price: Item.price,
					real_price: Item.real_price,
					short_name: Item.short_name,
					status: Item.status,
					summary: Item.summary,
					updated: Item.updated
				}
			})
		},

		graveyard_id: (state, getters) => {
			console.log("Graveyard-ID: ", state.graveyard_id)
			return state.graveyard_id
		},

		modelCount: (state, getters) => (model) => {
			if (typeof state[model] === 'undefined' || state[model] === null) {
				return 0
			}

			return state[model].length
		},

		models: (state, getters) => (model) => {
			return state[model].filter(value => {
				let result = false

				if (state.graveyard_id === 0) {
					// console.log("graveyard_id === 0", model)
					result = true
				}

				if (Array.isArray(value.graveyard_ids) && value.graveyard_ids.indexOf(state.graveyard_id) > -1) {
					// console.log("graveyard_ids", model)
					result = true
				}

				if (typeof value.graveyard_id === "number" && value.graveyard_id === state.graveyard_id) {
					// console.log("graveyard_id", model)
					result = true
				}

				if (!isData(value.graveyard_id) && !isData(value.graveyard_ids)) {
					// console.log("no graveyard id / graveyard ids", model)
					result = true
				}

				return result
			})
		},

		model: (state, getters) => (model, id) => {
			if (parseInt(id) === 0) {
				return getters.defaultModel(model)
			}

			let found = state[model].find(currModel => currModel.id === parseInt(id))
			if (typeof found === 'undefined' || found === null) {
				found = getters.defaultModel(model)
			}

			return found
		},

		filteredModel: (state, getters)	=> (model, criteria) => {
			let collection = getters.models(model)
			let localCriteria = criteria || state.localCriteria

			if (!Array.isArray(collection)) {
				return []
			}

			if (typeof localCriteria === "undefined" || typeof localCriteria.searchValue === "undefined") {
				return collection
			}

            let SearchFor = localCriteria.searchValue
				.split(',')
				.map(value => value.trim().toLowerCase())
				.filter(Value => Value !== "")

			if (SearchFor.length === 0) {
				return collection
			}

			let Cols = localCriteria.cols

			console.log(localCriteria, Cols)

			const finalResult = collection.filter(Item => {
				console.log("completeValue, andSearchMode, inclusiveSearchMode", localCriteria.completeValue, localCriteria.andSearchMode, localCriteria.inclusiveSearchMode)
				if (localCriteria.completeValue && !localCriteria.andSearchMode) {
					// Ganzes Wort, ODER-Modus
					const result = Cols.some(Col => SearchFor.some(Value => String(Item[Col]).toLowerCase() === Value))
					return localCriteria.inclusiveSearchMode ? result : !result
				} else if (!localCriteria.completeValue && !localCriteria.andSearchMode) {
					// Wort enthalten, ODER-Modus
					const result = Cols.some(Col => SearchFor.some(Value => String(Item[Col]).toLowerCase().indexOf(Value) > -1))
					return localCriteria.inclusiveSearchMode ? result : !result
				} else if (localCriteria.completeValue && localCriteria.andSearchMode) {
					// Ganzes Wort, UND-Modus
					const result = SearchFor.every(Value => Cols.some(Col => String(Item[Col]).toLowerCase() === Value))
					return localCriteria.inclusiveSearchMode ? result : !result
				} else if (!localCriteria.completeValue && localCriteria.andSearchMode) {
					// Wort enthalten, UND-Modus
					const result = SearchFor.every(Value => Cols.some(Col => String(Item[Col]).toLowerCase().indexOf(Value) > -1))
					return localCriteria.inclusiveSearchMode ? result : !result
				}

				return false
			})

			return finalResult
		},

		defaultModel: (state, getters) => (model) => {
			switch (model) {
				case 'customers':
					return {
						// Basisdaten
						'id': 0,
						'firstname': '',
						'lastname': '',
						'created_at': '0001-01-01T00:00:00Z',
						'updated_at': '0001-01-01T00:00:00Z',

						// Beziehungen
						'addresses': [],
						'contacts': [],
						'graves': [],
						'deceaseds': []
					}

				case 'deceaseds':
					return {
						id: 0,
						name: '',
						firstname: '',
						lastname: '',
						birthname: '',
						birthday: null,
						dyingday: null,
						burial: null,
						mourning: null,
						grave: '',
						gender: 0,
						deceased_id: 0,
						area: '',
						undertaker_id: 0,
						crematory_id: 0,
						undertaker_name: '',
						crematory_name: '',
						urn_number: '',
						burial_type: '',
						denomination: '',
						denomination_id: 0,
						birthplace: '',
					}

				case 'graves':
			 		return {
						id: 0,
						name: '',
						from: moment(Date.now()).format('YYYY-MM-DD'),
						until: moment(moment(Date.now()).add(25, 'years')).format('YYYY-MM-DD'),
						deceased: '',
						grave_id: 0
  					}

				case 'roles':
					return {
						id: 0,
						name: '',
						permission_id: 0,

						permissions: {
							dashboard: 1,
							deceaseds: 1,
							customers: 1,
							graves: 1,
							areas: 1,
							crematories: 1,
							undertakers: 1,
							users: 1,
							roles: 1,

							area_categories: 1,
							grave_categories: 1,
							burial_types: 1,
							denominations: 1
						},

						permissionsValues: {
							dashboard: '',
							deceaseds: '',
							customers: '',
							graves: '',
							areas: '',
							crematories: '',
							undertakers: '',
							users: '',
							roles: '',

							area_categories: '',
							grave_categories: '',
							burial_types: '',
							denominations: ''
						}
					}

					default:
						return {
							id: 0,
							name: '',
							area_id: 0,
							price: 0,
							description: ''
						}
				}
			}
		},

	mutations: {
		criteria (state, aCriteria) {
			// Compare the new criterias to the current criterias
			let Changed = false
			Changed = aCriteria.searchValue !== state.localCriteria.searchValue ? true : Changed
			Changed = aCriteria.completeValue !== state.localCriteria.completeValue ? true : Changed
			Changed = aCriteria.caseSensitive !== state.localCriteria.caseSensitive ? true : Changed

			Changed = aCriteria.sortAsc !== state.localCriteria.sortAsc ? true : Changed
			Changed = aCriteria.sortCol !== state.localCriteria.sortCol ? true : Changed
			Changed = aCriteria.andSearchMode !== state.localCriteria.andSearchMode ? true : Changed

			

			state.localCriteria = aCriteria
		},

		allAreas (state, aModels) {
			console.log(aModels, Array.isArray(aModels))
			if (Array.isArray(aModels) && aModels.length > 0) {
				state.allAreas = aModels.map(Item => {
					return {
						base_id: Item.base_id,
						category_id: Item.categories,
						category_price: Item.category_price,
						changed_by: Item.changed_by,
						coordinates: Item.coordinates,
						created: Item.created,
						customer_count: Item.customer_count,
						deceased_count: Item.deceased_count,
						deleted: Item.deleted,
						description: Item.description,
						grave_count: Item.grave_count,
						graveyard_id: Item.graveyard_id,
						graveyard_name: Item.graveyard_name,
						id: Item.id,
						name: Item.name,
						price: Item.price,
						real_price: Item.real_price,
						short_name: Item.short_name,
						status: Item.status,
						summary: Item.summary,
						updated: Item.updated
					}
				})
			}
		},

		graveyard_id (state, aID) {
			console.log("Set Graveyard-ID", aID)

			if (typeof aID === "undefined") {
				return
			}

			state.graveyard_id = aID
		},

		initModel (state, aModel) {
			state[aModel.name] = aModel.data
		},

		addModel (state, aModel) {
			state[aModel.name].push(aModel.data)
		},

		updateModel (state, aModel) {
			state[aModel.name] = state[aModel.name].map((aValue, aIndex, aArray) => {
				return aValue.id === aModel.data.id ? aModel.data : aValue
			})
		},

		clear (state) {
			state.areas = []
			state.customers = []
			state.users = []
			state.graves = []
			state.deceaseds = []
			state.contact_types = []
			state.address_types = []
			state.zips = []
			state.categories = []
			state.grave_types = []
			state.crematories = []
			state.undertakers = []
			state.burial_types = []
			state.denominations = []
			state.roles = []
			state.graveyards = []
			state.graveyard_id = 0
		},

		graveyard (state, aGraveyards) {
			state.graveyards = aGraveyards
		}
	},

	actions: {
		loadModel (context, aModel) {
			// Gibt es schon Einträge in der Collection?
			if (context.getters.modelCount(aModel) === 0 || ['areas', 'graves', 'customers', 'categories'].indexOf(aModel) > -1) {
				// Nein. Also versuchen wir, die Daten vom Server zu laden
				return new Promise((resolve, reject) => {
					axios.get('/api/' + aModel + '/')
					.then(response => {
						// Hat geklappt. Also die Daten in die Collection eintragen
						context.commit('initModel', { name: aModel, data: response.data })
						resolve(response.data)
					})
					.catch(err => {
						if (err.status === 401) {
							reject(err)
							return
						}

						// Das ging schief. Also versuchen wir, die Daten aus dem lokalen Speicher zu laden
						try {
							// var stored = localStorage.getItem(aModel);
							// context.commit("initModel", { name: aModel, data: stored });
							resolve([])
							return
						} catch (e) {
							resolve([])
						}
					})
				})
			} else {
				return new Promise((resolve, reject) => {
					resolve(context.getters.model(aModel))
				})
			}
		},

		loadModels (context, aModels) {
			let index
			let result
			let calls = []

			for (index = 0; index < aModels.length; index = index + 1) {
				calls.push(context.dispatch('loadModel', aModels[index]))
			}

			result = Promise.all(calls)
			return result
		},

		loadRelation (context, aRelation) {
			return new Promise((resolve, reject) => {
				var URL = '/api/' + aRelation.basis.name + '/' + aRelation.basis.model.id + '/' + aRelation.relation + '/'
				axios.get(URL)
				.then(response => {
					// Hat geklappt. Also die Daten in die Collection eintragen
					resolve(response.data)
				})
				.catch(err => {
					if (err.status === 401) {
						reject(err)
						return
					}

					// Das ging schief. Also versuchen wir, die Daten aus dem lokalen Speicher zu laden
					try {
						// var stored = localStorage.getItem(aModel);
						// resolve(stored);
						reject([])
						return
					} catch (e) {
						reject([])
					}
				})
			})
		},

		loadRelations (context, aRelations) {
			//
		},

		saveModel (context, aModel) {
			return new Promise((resolve, reject) => {
				console.log("!! store.actions.save !!")
				if (typeof aModel.validateModel !== "undefined" && !aModel.validateModel()) {
					console.log("!! store.actions.save.no_validateModel !!")
					reject()
					return
				}

				if (aModel.model.id === 0) {
					console.log("!! store.actions.save.model_id == 0 !!")
					// Neu anlegen
					axios.post('/api/' + aModel.name + '/', aModel.model)
					.then(response => {
						console.log("!! store.actions.save.model_id == 0.resolve !!")
						context.commit('addModel', {name: aModel.name, data: response.data})
						resolve(response.data)
					})
					.catch(err => {
						console.log("!! store.actions.save.model_id == 0.reject !!")
						reject(err)
					})
				} else {
					console.log("!! store.actions.save.model_id != 0 !!")
					// Aktualisieren
					axios.put('/api/' + aModel.name + '/' + aModel.model.id, aModel.model)
					.then(response => {
						console.log("!! store.actions.save.model_id != 0.resolve !!")
						context.commit('updateModel', {name: aModel.name, data: response.data})
						resolve(response.data)
					})
					.catch(err => {
						console.log("!! store.actions.save.model_id != 0.reject !!")
						reject(err)
					})
				}
			})
		},

		saveRelation (context, aRelation) {
			return new Promise((resolve, reject) => {
				aRelation.relation.validate()

				if (aRelation.relation.model.id === 0) {
					// Neu anlegen
					axios.post('/api/' + aRelation.basis.name + '/' + aRelation.basis.model.id + '/' + aRelation.relation.name + '/', aRelation.relation.model)
					.then(response => {
						resolve(response.data)
					})
					.catch(err => {
						reject(err)
					})
				} else {
					// Aktualisieren
					axios.put('/api/' + aRelation.basis.name + '/' + aRelation.basis.model.id + '/' + aRelation.relation.name + '/' + aRelation.relation.model.id, aRelation.relation.model)
					.then(response => {
						resolve(response.data)
					})
					.catch(err => {
						reject(err)
					})
				}
			})
		},

		updateModel (context, aModel) {
			/*
			return new Promise((resolve, reject) => {
				axios.get('/api/' + aModel.name + '/' + aModel.model.id)
				.then(response => {
					context.commit('updateModel', {name: aModel.name, data: response.data})
					resolve(response.data)
				})
				.catch(err => {
					reject(err)
				})
			})
			*/
		},

		/**
		* deleteRelation erwartet einen weiteren Parameter (der erste kommt von Vue).
		* Der Zweite Parameter ist ein Objekt, mit folgenden Eigenschaften:
		* - basis (Das Model das eine Beziehung zu einem anderen Model hat)
		* - relation (Die Collection zu der die Basis eine Beziehung hat)
		* - id (Der eindeutige Wert für ein Model innerhalb der Collection)
		* - name (Der Name des eindeutigen Feldes (standard: "id"))
		* @return Collection des Ziel-Models
		*/
		deleteRelation (context, aRelation) {
			return new Promise((resolve, reject) => {
				axios.delete('/api/' + aRelation.basis.name + '/' + aRelation.basis.model.id + '/' + aRelation.relation.name + '/' + aRelation.relation.model.id, aRelation.relation.model)
				.then(response => {
					resolve(response.data)
				})
				.catch(err => {
					reject(err)
				})
			})
		},

		deleteModel (context, aModel) {
			return axios.delete('/api/' + aModel.name + '/' + aModel.model.id)
		},

		graveyard (context) {
			axios.get("/api/graveyards/")
			.then(response => context.commit('graveyard', response.data))
			.catch(response => console.debug(response))
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store.js